import { DateTime } from 'luxon'

import { AnyProfile, AssetLatestCompany, Company, HistoryProfileEvent, ProfileType } from '@modules/search/types'

import { ProfileAlert } from './types'

interface Options {
  profile?: AnyProfile
  profileAlert?: ProfileAlert
  assetLatestCompany?: AssetLatestCompany
  type: ProfileType
  events?: HistoryProfileEvent[]
}

const checkIfNewEventRegistered = (data: {
  assetLatestCompany?: AssetLatestCompany
  viewedAtDate: DateTime
  type: ProfileType
  events?: HistoryProfileEvent[]
}) => {
  const { assetLatestCompany, type, viewedAtDate, events } = data
  const isNotAssetProfile = [ProfileType.company, ProfileType.delegate].includes(type)

  if (isNotAssetProfile) {
    return !!events?.find(event => {
      const createdAtDate = DateTime.fromISO(event.profileCreatedAt)
      const eventStartDate = DateTime.fromISO(event.startDate)

      return createdAtDate.toSeconds() > viewedAtDate.toSeconds() && eventStartDate.toSeconds() > viewedAtDate.toSeconds()
    })
  }

  if (!!assetLatestCompany?.createdAt && !!assetLatestCompany?.eventStartDate) {
    const createdAtDate = DateTime.fromISO(assetLatestCompany.createdAt)
    const eventStartDate = DateTime.fromISO(assetLatestCompany.eventStartDate)

    return createdAtDate.toSeconds() > viewedAtDate.toSeconds() && eventStartDate.toSeconds() > viewedAtDate.toSeconds()
  }

  return false
}

export const getProfileIsUpdated = (data: Options) => {
  const { profile, profileAlert, assetLatestCompany, type, events } = data
  if (!profileAlert || !profileAlert.lastViewedAt || !profile) {
    return false
  }

  const viewedAtDate = DateTime.fromISO(profileAlert.lastViewedAt)

  const isNewEventRegistered = checkIfNewEventRegistered({
    viewedAtDate,
    type,
    assetLatestCompany,
    events,
  })

  const { assetLatestCreatedAt } = profile as Company

  if (isNewEventRegistered || (!profile?.followedFieldsUpdatedAt && !assetLatestCreatedAt)) {
    return isNewEventRegistered
  }

  if (assetLatestCreatedAt) {
    const assetLatestCreatedAtDate = DateTime.fromISO(assetLatestCreatedAt)
    if (assetLatestCreatedAtDate.toSeconds() > viewedAtDate.toSeconds()) {
      return true
    }
  }

  const updatedAtDate = DateTime.fromISO(profile.followedFieldsUpdatedAt!)

  return updatedAtDate.toSeconds() > viewedAtDate.toSeconds()
}
